import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useAds } from "../../context/adsContext";
import useAuthedApi from "../../hooks/useAuthedApi";

export default function AdsComponent({ className }) {
  const { ads } = useAds();
  const { authedPost } = useAuthedApi(); // Get the authedPost function

  const { mutate: performAdClick } = useMutation({
    // The mutation function now uses authedPost and is much simpler
    mutationFn: (adId) => authedPost(`/api/ads/click/${adId}/`, {}),
    onError: (error) => {
      console.error("Failed to track ad click:", error.response?.data || error);
    },
  });

  const ad = Array.isArray(ads) ? ads?.[0] : ads;
  const imageUrl = ad?.image
    ? ad.image.startsWith("http://") || ad.image.startsWith("https://")
      ? ad.image
      : `${window.location.origin}${ad.image}`
    : null;

  const handleClick = (e) => {
    e.preventDefault();
    if (!ad?.id || !ad?.target_url) return;

    // Call the mutation with only the adId
    performAdClick(ad.id);

    // Redirect the user immediately
    window.open(ad.target_url, "_blank", "noopener,noreferrer");
  };

  if (!imageUrl) {
    return null;
  }

  return (
    <div
      onClick={handleClick}
      className={`w-full bg-white rounded-[10px] min-h-[100px] h-full bg-cover bg-center overflow-hidden cursor-pointer ${className}`}
      role="link"
      tabIndex={0}
      aria-label={ad.title || "Advertisement"}
    >
      <img
        src={imageUrl}
        alt={ad.title || "Advertisement"}
        className="w-full h-full object-cover"
      />
    </div>
  );
}
